module.exports = __webpack_public_path__ + "img/jakob_k.81600fba.jpg";